import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const AuthModal = ({ onClose }) => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = () => {
    loginWithRedirect({
      authorizationParams: {
        connection: 'email',
        screen_hint: 'signup'
      }
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1rem' }}>
          <img src="/aris_logo.png" alt="Aris" style={{ width: '50px', height: '50px', objectFit: 'contain' }} />
        </div>
        
        <h2 style={{ fontSize: '1.8rem', fontWeight: '700', marginBottom: '0.5rem', textAlign: 'center' }}>Start creating AI Ads.</h2>
        <p style={{ fontSize: '1.1rem', color: 'rgba(255, 255, 255, 0.6)', marginBottom: '2rem', textAlign: 'center' }}>
          Create free account
        </p>

        <button className="modal-button" onClick={handleLogin}>
          Sign Up
        </button>
      </div>
    </div>
  );
};

export default AuthModal;

